<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="2" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Filters</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="p-6">
      <vs-row >
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px" v-if="!displayForm">  
          <label class="vs-input--label">StatusMonitor</label>
          <v-select
            v-model="form.status"
            :options="statusMonitor"
            :reduce="el => el.value" label="text"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px" v-if="displayForm">
          <label class="vs-input--label">Status</label>
          <v-select
            v-model="form.status"
            :options="status"
            :reduce="el => el.value" label="text"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px; display: none">
          <label class="vs-input--label">Zone</label>
          <v-select
            @input="onZoneChange"
            v-model="form.zone_id"
            :options="zones"
            :reduce="el => el.id" label="name"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Route</label>
          <v-select
            :disabled="!form.zone_id"
            v-model="form.route_id"
            :options="routes"
            :reduce="el => el.id" label="name"  />
        </vs-col>
        <vs-col v-if="!partner_namespace" vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Partner</label>
          <v-select
            @input="onPartnerChange"
            v-model="form.partner_id"
            :options="partners"
            :reduce="el => el.id" label="name"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Vehicle</label>
          <v-select
            v-model="form.vehicle_id"
            :options="vehicles"
            :reduce="el => el.id"
            :get-option-label="(option)=>{ return `${option.plate} (${option.eco_number})`}"
            label="name"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Driver</label>
          <v-select
            v-model="form.driver_id"
            :options="drivers"
            :reduce="el => el.id" :get-option-label="(option)=>{ return `${option.firstname} ${option.lastname}`}" label="name"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px" v-if="!displayForm">
          <label class="vs-input--label">Order by</label>
          <v-select
            v-model="form.order_by"
            :options="orderBy"
            :reduce="el => el.value" label="text"  />
        </vs-col>
        <vs-col  vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px" v-if="!displayForm">
          <label class="vs-input--label">Order</label>
          <v-select
            v-model="form.order"
            :options="order"
            :reduce="el => el.value" label="text"  />
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submit" >Apply</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import {mapMutations, mapState, mapActions} from 'vuex';
  import {STATUS, STATUSMONITOR, MONITORORDERBY, MONITORORDER} from '../../constants/trips'
  import {cloneDeep} from 'lodash'
import { clone } from '@amcharts/amcharts4/.internal/core/utils/Object';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      default:{
        type: Object,

      },
      value:{
        type: Object
      }
    },
    components: {

    },
    data () {
      return {
        reloadvalue:false,
        form : {

        },
        displayForm : true,
        partners : [],
        zones: [],
        routes : [],
        vehicles: [],
        drivers : [],
        status: STATUS,
        statusMonitor: STATUSMONITOR,
        orderBy: MONITORORDERBY,
        order: MONITORORDER
      }
    },
    computed: {
      ...mapState(['partner_namespace']),
      isSidebarActiveLocal: {
        get () { 

          if(this.isSidebarActive){ 
            if(!this.reloadvalue){
              this.reloadvalue=true;
              this.initialData();
              console.log('load data here') 
            }
          }
         
          return this.isSidebarActive
        },
        set (val) {
          console.log('set val:', val)
          if (!val) { 
            this.reloadvalue=false;
            this.$emit('closeSidebar')
            // this.$validator.reset()
            // this.initValues()
          }
        }
      },
      ...mapState('trips',['filters']),
      formattedFilters(){
        let payload = {};
        for(let item in this.$route.query){
            switch (item) {
              case 'status':
                payload[item] = {
                  field : 'Status',
                  value: this.$route.query[item],
                  text : (this.status.find(el => el.value === this.$route.query[item])).text
                };
                break;
              case 'zone_id':
                let zone = this.zones.find(el => el.id === this.$route.query[item]);
                if(zone){
                  payload[item] = {
                    field : 'Zone',
                    value: this.$route.query[item],
                    text : zone.name
                  };
                }
                break;
              case 'route_id':
                let route = this.routes.find(el => el.id === this.$route.query[item]);
                if(route){
                  payload[item] = {
                    field : 'Route',
                    value: this.$route.query[item],
                    text : route.name
                  };
                }
                break;
              case 'partner_id':
                let partner = this.partners.find(el => el.id === this.$route.query[item]);
                if(partner){
                  payload[item] = {
                    field : 'Partner',
                    value: this.$route.query[item],
                    text : partner.name
                  };
                }
                break;
              case 'vehicle_id':
                let vehicle = this.vehicles.find(el => el.id === this.$route.query[item]);
                if(vehicle){
                  payload[item] = {
                    field : 'Vehicle',
                    value: this.$route.query[item],
                    text : `${vehicle.plate} (${vehicle.eco_number})`
                  };
                }
                break;
              case 'driver_id':
                let driver = this.drivers.find(el => el.id === this.$route.query[item]);
                if(driver){
                  payload[item] = {
                    field : 'Driver',
                    value: this.$route.query[item],
                    text : `${driver.firstname} ${driver.lastname}`
                  };
                }
                break;
              case 'order_by':
                payload[item] = {
                  field : 'Order by',
                  value: this.$route.query[item],
                  text : (this.orderBy.find(el => el.value === this.$route.query[item])).text
                };
                break;
              case 'order':
                payload[item] = {
                  field : 'Order',
                  value: this.$route.query[item],
                  text : (this.order.find(el => el.value === this.$route.query[item])).text
                };
                break;
            }
        }
        this.$emit('input', payload);
        return payload;
      },
    },
    watch: {
      filters(newValue, oldValue){
        let form = {};
        for(let key in newValue){
          form[key] = newValue[key].value;
        } 
        this.form = form;
      },
      default(newValue, oldValue){
        this.form = newValue;
        this.submit();
      },
      formattedFilters(newValue, oldValue){
        this.$emit('input', newValue);
        //this.SET_FILTERS(newValue);
      }
    },
    created() {
      
    },
    mounted(){
      this.form = {...this.$route.query};
       
    },
    methods: {
      ...mapActions('zones',['fetchZones']),
      ...mapActions('partners',['fetchPartners']),
      ...mapActions('vehicles',['fetchVehicles']),
      ...mapActions('drivers',['fetchDrivers']),
      ...mapActions('routes',['fetchRoutes']),
      ...mapMutations('trips',['SET_FILTERS']),
      ...mapActions('zones',['getPartnerZones']),
      initialData(){
        if(!this.partner_namespace){
          this.fetchZones({limit: 400}).then(data=>{
            this.zones = _.cloneDeep(data);
            if(this.zones.length === 1){
              this.form.zone_id = this.zones[0].id;
            }
            if(this.form.zone_id){
              this.onZoneChange();
            }
          });
          this.fetchPartners({limit: 500}).then(data=>{
            this.partners = _.cloneDeep(data.data.partners);
            if(this.form.partner_id){ 
              this.onPartnerChange(false, false);
            }
          });
        }else{
          this.getPartnerZones({partner_id: this.partner_namespace})
            .then(data=>{
              this.zones = _.cloneDeep(data.zones);
              if(this.zones.length === 1){
                this.form.zone_id = this.zones[0].id;
              }
              if(this.form.zone_id){
                this.onZoneChange();
              }
            })
            .catch(error =>{

            })
          this.form.partner_id = this.partner_namespace; 
          this.onPartnerChange();
        }

        if(this.$route.name === 'partner.trips.monitor' || this.$route.name === 'trips.monitor'){
          this.displayForm = false
        }
      },

      onZoneChange(){
        delete this.form.route_id;
        this.fetchRoutes({limit: 500, zone_id: this.form.zone_id})
          .then(data=>{
            this.routes = data.routes;
          })
          .catch(error=>{

          })
      },
      onPartnerChange(resetDriver = true, resetVehicle=true){  
        this.vehicles = [];
        this.drivers = [];  
        if (resetDriver) delete this.form.driver_id;
        if(resetVehicle) delete this.form.vehicle_id;
        this.fetchVehicles({limit: 1000, partner_id: this.form.partner_id}).then(data=>{
          this.vehicles = _.cloneDeep(data.vehicles);
        });
        this.fetchDrivers({limit: 1000, partner_id: this.form.partner_id}).then(data=>{
          this.drivers = _.cloneDeep(data.drivers);
        });
      },
      submit () {
        let payload = {};  
        for(let item in this.form){
          if(this.form[item]){
            switch (item) {
              case 'status':
                payload[item] = {
                  field : 'Status',
                  value: this.form[item],
                  text : (this.status.find(el => el.value === this.form[item])).text
                };
                break;
              case 'zone_id':
                payload[item] = {
                  field : 'Zone',
                  value: this.form[item],
                  text : (this.zones.find(el => el.id === this.form[item])).name
                };
                break;
              case 'route_id':
                payload[item] = {
                  field : 'Route',
                  value: this.form[item],
                  text : (this.routes.find(el => el.id === this.form[item])).name
                };
                break;
              case 'partner_id':
                if(!this.partner_namespace){
                  payload[item] = {
                    field : 'Partner',
                    value: this.form[item],
                    text : (this.partners.find(el => el.id === this.form[item])).name
                  };
                }
                break;
              case 'vehicle_id':
                let vehicle = this.vehicles.find(el => el.id === this.form[item]);
                payload[item] = {
                  field : 'Vehicle',
                  value: this.form[item],
                  text : `${vehicle.plate} (${vehicle.eco_number})`
                };
                break;
              case 'driver_id':
                let driver = this.drivers.find(el => el.id === this.form[item]);
                payload[item] = {
                  field : 'Driver',
                  value: this.form[item],
                  text : `${driver.firstname} ${driver.lastname}`
                };
                break;
              case 'order_by':
                payload[item] = {
                  field : 'Order by',
                  value: this.form[item],
                  text : (this.orderBy.find(el => el.value === this.form[item])).text
                };
                break;
              case 'order':
                payload[item] = {
                  field : 'Order',
                  value: this.form[item],
                  text : (this.order.find(el => el.value === this.form[item])).text
                };
                break;

            }
          }

        }
        this.isSidebarActiveLocal = false;
        this.$emit('submit', payload);
        this.SET_FILTERS(payload);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
